import UnicornApp from '../app';
export default class UnicornQueue {
    app;
    queues = {};
    static is = 'queue';
    static install(app) {
        const $queue = app.$queue = new this(app);
        app.queue = $queue.get.bind($queue);
    }
    constructor(app) {
        this.app = app;
        //
    }
    create(maxRunning = 1) {
        return new SimpleQueue(maxRunning);
    }
    get(name, maxRunning = 1) {
        if (name == null) {
            throw new Error('Please provide a name.');
        }
        if (!this.queues[name]) {
            this.queues[name] = this.create(maxRunning);
        }
        return this.queues[name];
    }
    set(name, queue) {
        this.queues[name] = queue;
        return this;
    }
    remove(name) {
        delete this.queues[name];
        return this;
    }
    all() {
        return this.queues;
    }
}
export class SimpleQueue {
    maxRunning;
    items = [];
    currentRunning = 0;
    running = false;
    observers = [];
    constructor(maxRunning = 1) {
        this.maxRunning = maxRunning;
        //
    }
    push(callback) {
        const p = new Promise((resolve, reject) => {
            this.items.push(() => {
                return Promise.resolve(callback()).then(resolve);
            });
        });
        this.run();
        return p;
    }
    run() {
        if (!this.running) {
            this.running = true;
        }
        this.pop();
    }
    async pop() {
        const callback = this.items.shift();
        // If empty, stop running.
        if (!callback) {
            this.running = false;
            return Promise.resolve();
        }
        // If current running full, set back to queue and leave.
        if (this.currentRunning >= this.maxRunning) {
            this.items.unshift(callback);
            return Promise.resolve();
        }
        this.currentRunning++;
        this.notice();
        try {
            return await callback();
        }
        catch (e) {
            throw e;
        }
        finally {
            this.endPop();
        }
    }
    endPop() {
        this.currentRunning--;
        this.notice();
        this.pop();
    }
    clear() {
        this.items = [];
        this.notice();
        return this;
    }
    isEmpty() {
        return this.items.length === 0;
    }
    get length() {
        return this.items.length;
    }
    peek() {
        return this.items;
    }
    observe(handler, options = {}) {
        this.observers.push({
            handler,
            once: options.once || false
        });
        return () => {
            this.off(handler);
        };
    }
    once(handler, options = {}) {
        options.once = true;
        return this.observe(handler, options);
    }
    onEnd(callback, options = {}) {
        return this.observe((queue, length, running) => {
            if (length === 0 && running === 0) {
                callback(queue, length, running);
            }
        }, options);
    }
    notice() {
        this.observers.forEach((observer) => {
            observer.handler(this, this.length, this.currentRunning);
        });
        this.observers = this.observers.filter((observer) => !observer.once);
        return this;
    }
    off(callback) {
        if (callback == null) {
            this.observers = [];
            return this;
        }
        this.observers = this.observers.filter((observer) => observer.handler !== callback);
        return this;
    }
}
